import { Identifiable } from "./identifiable";
import { List } from "./list";
import { Project } from "./project";
import { Status } from "./status";

type RetrieveTasksFilter = {
  project?: Identifiable<Project>;
  list?: Identifiable<List>;
  status?: Identifiable<Status>;
};

const retrieveTasksFilter: RetrieveTasksFilter = {};

export type { RetrieveTasksFilter };

export { retrieveTasksFilter };
